import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { findOrderByCode } from 'components/graphql/queries'
import { stripUriParamsString } from 'lib/utils/helpers';
import QRCode from 'qrcode.react';
import React, { useCallback, useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap';

import { ResponsiveScatterPlot } from '@nivo/scatterplot'

import Moment from 'react-moment'
import Description from '../CampaignsDashboard/Description';

import MapComponent from '../../../components/map'

import { geocodeByPlaceId } from 'react-google-places-autocomplete';

const Receipt: React.FC<{ [label: string]: any }> = (props: any) => {

    const [orderId] = useState(stripUriParamsString(props.match.params.orderId))
    const [order, setOrder] = useState<any>({
        buyerEmail: '',
        buyerName: '',
        buyerAddress: '',
        orderComponents: [
            { name: '', price: 0, count: 0 }
        ],
        campaign: {
            name: '',
            description: '',
            collectAddress: false,
            hideDisplayTime: false,
            surveyQuestion: '',
            startTime: {
                year: 0,
                month: 0,
                day: 0,
                hour: 0,
                minute: 0,
                PM: true
            },
            media: {
                logo: ''
            },
            floorplan: {
                labels: [],
                inventoryMap: [],
                height: 0,
                width: 0
            },
            location: null,
            secretLocation: null
        },
        boughtAt: new Date(),
        stripeFee: 0,
        platformFee: 0,
        subtotal: 0,
        code: '',
        floorplanLocation: null

    })

    const [error, setError] = useState(false)
    const [data, setData] = useState([])
    const [imageHeight, setImageHeight] = useState(0)
    const [marker, setMarker] = useState<any>(null)

    const onImgLoad = useCallback(({ target: img }) => {
        setImageHeight(img.offsetHeight)
    }, [setImageHeight])

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: findOrderByCode,
                variables: {
                    code: orderId
                }
            })
            .then(res => {
                if (res.data.data.order.findByCode) {
                    const orderObj = res.data.data.order.findByCode
                    setOrder(orderObj)
                    if (orderObj.floorplanLocation) {
                        const initData: any = []
                        const unavailable: any[] = []
                        orderObj.campaign.floorplan.inventoryMap.map((item: any) => {
                            if (item.x === orderObj.floorplanLocation.x && item.y === orderObj.floorplanLocation.y) {
                                initData.push({
                                    id: 'Purchased',
                                    data: [{
                                        x: item.x, y: item.y
                                    }]
                                })
                            } else {
                                unavailable.push({
                                    x: item.x, y: item.y
                                })
                            }
                        })
                        orderObj.campaign.floorplan.labels.map((item: any) => {
                            initData.push({
                                id: item.label,
                                data: [{ x: item.x, y: item.y }]
                            })
                        })
                        initData.push({
                            id: 'Unavailable',
                            data: unavailable
                        })
                        setData(initData)
                    }
                } else {
                    setError(true)
                }
            })
            .catch(err => {
                console.log(err)
                setError(true)
            })
    }, [orderId, setOrder, setError, setData])

    const CustomNode = useCallback(({
        node,
        x,
        y,
        size,
        color,
        blendMode,
        onMouseEnter,
        onMouseMove,
        onMouseLeave,
        onClick,
    }) => {

        const label: any = order.campaign.floorplan ? order.campaign.floorplan.labels.find((i: any) => {
            return i.label.toString().trim() === node.data.serieId.toString().trim()
        }) : null

        if (!label) {
            return (
                <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                    <circle
                        stroke={node.data.serieId.toString().trim() === 'Unavailable'.toString().trim() ? "#242d51" : '#f1f1f1'}
                        stroke-width="0.5"
                        fill-opacity={node.data.serieId.toString().trim() === 'Unavailable'.toString().trim() ? 0.4 : 1}
                        stroke-opacity={0.75}
                        r={size * 0.5}
                        fill={node.data.serieId.toString().trim() === 'Unavailable'.toString().trim() ? '#f1f1f1' : '#d63191'}
                        style={{ mixBlendMode: blendMode, zIndex: 15000000, opacity: 1 }}
                        onMouseEnter={onMouseEnter}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseLeave}
                        onClick={onClick}
                    />
                </g>
            )
        }
        return (
            <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                <text
                    x={size * -1}
                    y={size * 0.5}
                    font-size='8px'
                    font-style='bold'
                    color='#1931b9'
                    font-color='#1931b9'
                    style={{ zIndex: 150, opacity: 1 }}
                >
                    {label.label.toUpperCase()}
                </text>
            </g>
        )
    }, [order, data])

    useEffect(() => {
        if (order.campaign.location !== undefined && order.campaign.location !== null) {
            const loc = JSON.parse(order.campaign.location)
            geocodeByPlaceId(loc.value.place_id)
                .then(results => {
                    const mark = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng()
                    }
                    setMarker(mark)
                })
                .catch(e => console.error(e));
        }
    }, [order.campaign])

    return <div>
        <div style={{ height: 'auto' }}>
            <div className='container'>
                <div className="div_holder_2">
                    <div
                        className="div_holder_4"
                        style={{
                            color: "#242d51"
                        }}
                    >
                        <p />
                        <div
                            className="col-sm-12 pt-2"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                paddingLeft: '10%', paddingRight: '10%'
                            }}
                        >
                            <div
                                className="row"
                                style={{ maxWidth: "800px", }}
                            >
                                <div className="col text-center">
                                    <h3 className="sexyBlack pb-2">{order.campaign.name}</h3>
                                    {
                                        error ?
                                            <div>
                                                <h6 style={{ textAlign: 'center' }} className="sexyBlack">
                                                    <strong>
                                                        Page not found<br />
                                                        <small>Contact orders@isotopeticketing.com for more info.</small><br /><br />
                                                    </strong>
                                                </h6>
                                            </div>
                                            :
                                            <div>
                                                <h6 style={{ textAlign: 'center' }} className="sexyBlack">
                                                    <strong>
                                                        Order Confirmed<br />
                                                        <small>Check email for confirmation</small><br /><br />
                                                    </strong>
                                                </h6>
                                                <blockquote className="text-gray" style={{ paddingRight: '5%', paddingLeft: '5%', fontSize: '11px' }}>
                                                    Your order has been sent to your email. Please save or
                                                    screenshot this page for record if you have not
                                                    received an email with your order confirmation from
                                                    orders@isotopeticketing.com
                                                </blockquote>
                                                <br />
                                                <div className="row" style={{ paddingRight: '5%', paddingLeft: '5%' }}>
                                                    <div className="col-md-6 col-lg-6 col-sm-6 pb-3">
                                                        <QRCode
                                                            renderAs="svg"
                                                            value={order.code}
                                                            size={150}
                                                        />
                                                    </div>
                                                    <div
                                                        className="col-md-6 col-lg-6 col-sm-6"
                                                        style={{
                                                            textAlign: "left"
                                                        }}
                                                    >
                                                        <p>
                                                            <b className="text-gray pr-2">Order ID</b>
                                                            <span className="ticket-info right">
                                                                {" "}
                                                                {order.code}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            <b className="text-gray pr-2">Customer</b>
                                                            <span className="ticket-info right">
                                                                {" "}
                                                                {order.buyerName}
                                                            </span>
                                                        </p>
                                                        {
                                                            order.campaign.collectAddress ?
                                                                <p>
                                                                    <b className="text-gray pr-2">
                                                                        {
                                                                            order.campaign.surveyQuestion}
                                                                    </b>
                                                                    <span className="ticket-info right">
                                                                        {" "}
                                                                        {order.buyerAddress}
                                                                    </span>
                                                                </p> : null
                                                        }
                                                        {
                                                            order.campaign.hideDisplayTime ? null :
                                                                <p>
                                                                    <b className="text-gray pr-2">Time</b>
                                                                    <span className="ticket-info right">
                                                                        <Moment format="D MMM 'YY, " style={{ paddingRight: '5px', paddingLeft: '4px' }}>
                                                                            {Number(new Date(
                                                                                order.campaign.startTime.year,
                                                                                order.campaign.startTime.month - 1,
                                                                                order.campaign.startTime.day,
                                                                                (order.campaign.startTime.PM ? order.campaign.startTime.hour + 12 : order.campaign.startTime.hour),
                                                                                order.campaign.startTime.minute
                                                                            ))}
                                                                        </Moment>
                                                                        <Moment format="hh:mm A">
                                                                            {Number(new Date(
                                                                                order.campaign.startTime.year,
                                                                                order.campaign.startTime.month - 1,
                                                                                order.campaign.startTime.day,
                                                                                (order.campaign.startTime.PM ? order.campaign.startTime.hour + 12 : order.campaign.startTime.hour),
                                                                                order.campaign.startTime.minute
                                                                            ))}
                                                                        </Moment>
                                                                    </span>
                                                                </p>
                                                        }
                                                        <p>
                                                            <b className="text-gray pr-2">Description</b>
                                                            <span className="ticket-info right">
                                                                {" "}
                                                                <Description>
                                                                    {order.campaign.description}
                                                                </Description>
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%' }}>
                                                    {
                                                        marker ?
                                                            <div style={{ maxWidth: 500, flex: 1 }}>
                                                                <MapComponent
                                                                    marker={marker}
                                                                />
                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                                <div>
                                                    <div style={{ position: 'relative', marginTop: '10px' }}>
                                                        <div style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>
                                                            {
                                                                order.campaign.media.logo && order.floorplanLocation ?
                                                                    <img src={order.campaign.media.logo ? order.campaign.media.logo : undefined}
                                                                        onLoad={e => onImgLoad(e)}
                                                                        style={{
                                                                            width: '100%', opacity: 0.75, zIndex: 30, borderRadius: '10px',
                                                                            maxWidth: '100%'
                                                                        }} />
                                                                    : null
                                                            }
                                                        </div>
                                                        <div style={{
                                                            position: 'absolute',
                                                            height: order.campaign.media.logo ? (
                                                                screen.width >= 768 ? imageHeight - 25 : imageHeight - 12
                                                            ) : (order.campaign.floorplan !== null ? order.campaign.floorplan.height * 25 : '0px'),
                                                            width: '100%',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            zoom: 100 / 92
                                                        }}>
                                                            <div style={{
                                                                height: order.campaign.media.logo ? (
                                                                    screen.width >= 768 ? imageHeight - 25 : imageHeight - 12
                                                                ) : (order.campaign.floorplan !== null ? order.campaign.floorplan.height * 25 : '0px'),
                                                                width: '100%'
                                                            }}>
                                                                <ResponsiveScatterPlot
                                                                    data={data}
                                                                    margin={{
                                                                        top: screen.width >= 768 ? 20 : 15,
                                                                        bottom: screen.width >= 768 ? 20 : 15,
                                                                        left: screen.width >= 768 ? 20 : 15,
                                                                        right: screen.width >= 768 ? 20 : 15
                                                                    }}
                                                                    xScale={{
                                                                        type: 'linear', min: 0,
                                                                        max: order.campaign.floorplan ? order.campaign.floorplan.width - 1 : 10
                                                                    }}
                                                                    yScale={{
                                                                        type: 'linear', min: 0,
                                                                        max: order.campaign.floorplan ? order.campaign.floorplan.height - 1 : 10
                                                                    }}
                                                                    enableGridX={false}
                                                                    enableGridY={false}
                                                                    axisTop={null}
                                                                    axisRight={null}
                                                                    axisLeft={null}
                                                                    axisBottom={null}
                                                                    onClick={(n, e) => undefined}
                                                                    colors={{ scheme: 'blues' }}
                                                                    renderNode={CustomNode}
                                                                    tooltip={({ node }: any) => null}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-lg-12 col-sm-12" style={{
                                                    marginTop: order.floorplanLocation ?
                                                        (order.campaign.media.logo ? imageHeight + 25 : order.campaign.floorplan.height * 26)
                                                        : '0px'
                                                }}>
                                                    <br />
                                                    <table className="table">
                                                        <tr>
                                                            <th className="text-left">Item</th>
                                                            <td className="text-center" />
                                                            <th className="text-center">Price</th>
                                                        </tr>
                                                        {
                                                            order.orderComponents.map(component => {
                                                                return (
                                                                    <tr key={"aaa" + component.name}>
                                                                        <td className="text-left">{component.name} x {component.count}</td>
                                                                        <td className="text-center" />
                                                                        <td className="text-center">
                                                                            ${(component.price / 100).toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        }
                                                        <React.Fragment>
                                                            <tr>
                                                                <th className="text-left"><b>Subtotal</b></th>
                                                                <td className="text-center" />

                                                                <td className="text-center">
                                                                    <b>
                                                                        ${(order.subtotal / 100).toFixed(2)}
                                                                    </b>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th className="text-left">Service Fees</th>
                                                                <td className="text-center" />
                                                                <td className="text-center">
                                                                    ${(order.platformFee / 100).toFixed(2)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th className="text-left">Card Processing Fees</th>
                                                                <td className="text-center" />
                                                                <td className="text-center">
                                                                    ${(order.stripeFee / 100).toFixed(2)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th className="text-left"><b>Total Amount Paid</b></th>
                                                                <td className="text-center" />
                                                                <td className="text-center">
                                                                    <b>
                                                                        ${((order.subtotal + order.stripeFee + order.platformFee) / 100).toFixed(2)}
                                                                    </b>
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    </table>
                                                    <p className="text-center">
                                                        <br />
                                                        <b className="text-gray">{Number(order.subtotal) === 0 ? 'Confirmed At   ' : 'Purchased At   '}</b>
                                                        <span className="ticket-info right">
                                                            <Moment format="D MMM 'YY, ">
                                                                {Number(new Date(order.boughtAt))}
                                                            </Moment>
                                                            <Moment format="hh:mm A">
                                                                {Number(new Date(order.boughtAt))}
                                                            </Moment>
                                                        </span>
                                                    </p>
                                                    <p style={{ fontSize: '11px', paddingBottom: '20px' }}>
                                                        For any questions regarding your order, please contact
                                                        us at
                                                        <br />
                                                        orders@isotopeticketing.com
                                                    </p>
                                                </div>
                                            </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                </div>
                {
                    error ? null :
                        <Row style={{ textAlign: 'center' }}>
                            <Col style={{ paddingBottom: '20px' }}>
                                <div className='big-split-768' style={{ width: '100%', display: screen.width >= 768 ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ width: '33%' }}>
                                        <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                                            <h6 className='gray-text' >
                                                &copy; Isotope Ticketing 2020
                                            </h6>
                                        </a>
                                    </div>
                                    <div style={{ width: '34%' }}>
                                        <a href="https://www.facebook.com/isotopeticketing/" className="fa fa-facebook" />
                                        <a href="https://www.youtube.com/watch?v=hX9KJdHSxew" className="fa fa-youtube" />
                                        <a href="https://www.instagram.com/isotopeticketing/" className="fa fa-instagram" />
                                    </div>
                                    <div style={{ width: '33%' }}>
                                        <h6 className='gray-text'>
                                            Powered by Stripe
                                        </h6>
                                    </div>
                                </div>
                                <div className='small-split-768' style={{ textAlign: 'center' }}>
                                    <div style={{ width: '100%' }}>
                                        <a style={{ cursor: 'pointer', textDecoration: 'none' }} href='https://www.isotopeticketing.com' target="_blank">
                                            <h6 className='gray-text' >
                                                &copy; Isotope Ticketing 2020<br /><br />
                                            </h6>
                                        </a>
                                    </div>
                                    <div style={{ width: '100%' }}>
                                        <a href="https://www.facebook.com/isotopeticketing/" className="fa fa-facebook" />
                                        <a href="https://www.youtube.com/watch?v=hX9KJdHSxew" className="fa fa-youtube" />
                                        <a href="https://www.instagram.com/isotopeticketing/" className="fa fa-instagram" />
                                    </div>
                                    <div style={{ width: '100%' }}>
                                        <h6 className='gray-text'>
                                            <br />Powered by Stripe
                                        </h6>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                }
            </div>
        </div>
    </div>
}

export default Receipt;


// WEBPACK FOOTER //
// ./src/pages/campaign/SellPage/Receipt.tsx